export const phoneRegExp =
	/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

// New comprehensive phone number regex allowing spaces, dashes, or parentheses
export const PHONE_NUMBER_REGEX =
	/^(\+?[0-9]{1,4}[-.\s]?)?(\(?[0-9]{1,4}\)?[-.\s]?)*[0-9]{3,9}$/;

export const CODE_REGEX = /^[A-Za-z0-9_-]*$/;

export const CONTRACT_CODE_REGEX = /^[A-Z0-9]*$/;

// Tax number regex - allows 7, 10, 12, or 14 characters, with dash at 11th position for 14-char
export const TAX_NUMBER_REGEX =
	/^([0-9]{7}|[0-9]{10}|[0-9]{12}|[0-9]{10}-[0-9]{3})$/;

export const PRODUCT_CODE_NUMBER_VALIDATION_REGEX = /^[A-Z0-9-_]*$/;

export const MONTHS = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

/**
 * Fallback year list before auth boot returns `working_years`.
 * Prefer `store.getters.getWorkingYears` after login / abilities / cai-dat.
 */
export const currentSelectableYear = [new Date().getFullYear()];

export const DUPPLICATE_SUPPLY_META_KEY = 'Dữ liệu đã tồn tại';

export enum PRODUCT_SELECTING_PROGRESS {
	NOT_SELECTING = 'NOT_SELECTING',
	SELECTING_CATEGORY = 'SELECTING_CATEGORY',
	SELECTING_PRODUCT = 'SELECTING_PRODUCT',
	DONE = 'DONE',
}

export enum LOAI_DINH_MUC {
	NGOAI_DINH_MUC = 'NDM',
	DINH_MUC_CO_DINH = 'DMCD',
	TAT_CA_DINH_MUC = 'TCDM',
}

export const DEFAULT_PER_PAGE_KEY = 'DEFAULT_PER_PAGE_KEY';

export const ASIDE_MINIMIZE_STATE_KEY = 'ASIDE_MINIMIZE_STATE';

export const TOKEN_INVALID = 'Token is Invalid';

export const TOKEN_EXPIRED = 'Token is Expired';

export const AUTH_TOKEN_ERROR_MESSAGES = [TOKEN_INVALID, TOKEN_EXPIRED] as const;
